import { jsxs, jsx } from "react/jsx-runtime";
import "../../../assets/IconSpinner.js";
import useThemePresetClasses from "../../../hooks/useThemePresetClasses.js";
import { cn } from "../../../utils/cn.js";
import SvgStar from "../../../assets/vuesax/star.svg.js";
const PageTitle = ({
  children,
  variant = "solid",
  className,
  classes,
  label,
  backButton,
  rightButton
}) => {
  const { themeClasses } = useThemePresetClasses("PageTitle", classes, className, {
    variant
  });
  return /* @__PURE__ */ jsxs("div", { className: cn("flex flex-col items-center", themeClasses == null ? void 0 : themeClasses.root), children: [
    /* @__PURE__ */ jsxs("div", { className: "relative flex w-full items-center", children: [
      variant === "solid" && /* @__PURE__ */ jsx("span", { className: cn("mx-auto", themeClasses == null ? void 0 : themeClasses.label), children: label }),
      variant === "gradient-yellow" && /* @__PURE__ */ jsxs("div", { className: "relative h-[35px] w-full", children: [
        /* @__PURE__ */ jsx("span", { className: cn("absolute left-1/2 top-[1px] -translate-x-1/2", themeClasses == null ? void 0 : themeClasses.label), children: label }),
        /* @__PURE__ */ jsx("span", { className: cn("absolute left-1/2 top-0 -translate-x-1/2", themeClasses == null ? void 0 : themeClasses.labelOverlay), children: label }),
        /* @__PURE__ */ jsx("span", { className: cn("absolute left-1/2 -translate-x-[50%] -translate-y-[16px]", themeClasses == null ? void 0 : themeClasses.star), children: /* @__PURE__ */ jsx(SvgStar, {}) })
      ] }),
      variant === "gradient-purple" && /* @__PURE__ */ jsxs("div", { className: "relative h-[35px] w-full", children: [
        /* @__PURE__ */ jsx("span", { className: cn("absolute left-1/2 top-[1px] -translate-x-1/2", themeClasses == null ? void 0 : themeClasses.label), children: label }),
        /* @__PURE__ */ jsx("span", { className: cn("absolute left-1/2 top-0 -translate-x-1/2", themeClasses == null ? void 0 : themeClasses.labelOverlay), children: label })
      ] }),
      /* @__PURE__ */ jsx("div", { className: "absolute left-0", children: backButton }),
      /* @__PURE__ */ jsx("div", { className: "absolute right-0", children: rightButton })
    ] }),
    children
  ] });
};
const PageTitle$1 = PageTitle;
export {
  PageTitle$1 as default
};
